export default __webpack_public_path__ + "static/media/ownership-pic.ce1a9922.svg";